import { EnvironmentType } from '@/configs/environments/types'

export const config: EnvironmentType = {
  type: 'stage',
  adisonOfwList: {
    baseUrl: 'https://api-ao-list-stg.adison.co/api'
  },
  adisonOfw: {
    baseUrl: 'https://api-ao-stg.adison.co/api'
  },
  adisonOfwGlobal: {
    baseUrl: 'https://api-ao-stg.g.adison.co/api'
  }
}
